import i18n from "@/i18n";
import services from "@/composable/services";
import { HttpStatusCodes } from "@/utils/HttpUtils";
import { DefaultValidationCheckResult, ValidationCheckResultRest } from "@/types/generated/UsedGeneratedTypes";

export type ErrorType = {
  httpResponseCode: number;
  content: Promise<ValidationCheckResultRest[] | DefaultValidationCheckResult[]>;
  [key: string]: any;
  message: string;
  messageParams?: any;
};

export async function checkMessageErrors(
  errors: ErrorType,
  errorsList: ValidationCheckResultRest[] | DefaultValidationCheckResult[],
  errorsMessages: string | string[],
): Promise<string | string[]> {
  if (errors.httpResponseCode === HttpStatusCodes.BAD_REQUEST) {
    await errors.content.then((value: ValidationCheckResultRest[] | DefaultValidationCheckResult[]) => {
      for (let i = 0; i < value.length; i++) {
        errorsList[i] = value[i];
      }
      if (errorsList.length !== 0) {
        errorsMessages = services.errorsService.getCsvErrorsMessages(errorsList as ValidationCheckResultRest[]);
      }
      else {
        errorsMessages = services.errorsService.getErrorsMessages(errorsList as DefaultValidationCheckResult[]);
      }
    });
  }
  else {
    services.alertService.toastError(i18n.global.t("alert.delete-reference-error"), errors);
  }
  return errorsMessages;
}
